export const DEFAULT_BACKGROUND =
  'https://ik.imagekit.io/guild/social-card-default-background_jsJLeMecN.png'

export const GRADIENT_IMAGE_URL =
  'https://ik.imagekit.io/guild/default_gradient_BBOVz2tl6.png'

export const HERO_BACKGROUND_IMAGE_URL =
  'https://ik.imagekit.io/guild/hero_background_bright_6B4GXB3NT.png'
